<template>
    <li :class="wrapperClass" @click="selectItem" style="width: 100%;">
        <div class="pr-3" style="z-index: 1;">
            <img class="handle icon ui-sortable-handle" src="@/assets/svg/more-vertical.svg">
        </div>
        <div class="input-table-shadow reservation-line-row">
            <div style="width: 100%;" class="d-flex align-items-center" :class="{ 'row-green': item.statusCode === 'DONE', 'row-blue': item.statusCode === 'TODO', 'row-orange': item.statusCode === 'PENDING', 'row-red': item.statusCode === 'CANCELLED' || item.statusCode === 'DECLINED' }">
                <div class="col col-60px border-right" v-click-outside="outsideCodeSearch">
                  <img src="@/assets/svg/refresh-ccw.svg" alt="loading" v-if="!item.bedsCacheExists" class="rotating" />
                  <input
                        type="text"
                        :placeholder="$t('reservation.service-list.code')"
                        @click="toggleCodeSearch"
                        v-model="item.service.code"
                        v-show="item.bedsCacheExists"
                    >
                    <core-paginated-drop-down
                        v-if="localServiceTypes.length && showCodeSearch"
                        :filters="localServiceTypes"
                        searchProperty="code"
                        filterPropertyName="serviceTypeId"
                        :item.sync="item.service"
                    ></core-paginated-drop-down>
                </div>
                <div class="col-2 border-right" v-click-outside="outsideNameSearch">
                    <input
                        type="text"
                        :placeholder="$t('reservation.service-list.service')"
                        @click="toggleNameSearch"
                        v-model="item.service.title_NL"
                    >
                    <core-paginated-drop-down
                        v-if="localServiceTypes.length"
                        v-show="showNameSearch"
                        :filters="localServiceTypes"
                        filterPropertyName="serviceTypeId"
                        :item.sync="item.service"
                    ></core-paginated-drop-down>
                </div>
                <div class="col-2 border-right" v-if="!item.buildingBlock">
                  <input type="text" v-model="item.reference">
                </div>
                <div class="col col-50px border-right bg-lightdark" v-if="!item.buildingBlock">
                  <core-calendar
                    v-if="item.statusCode !== 'DONE' && item.statusCode !== 'CANCELLED'"
                    @change="handleCalendarChange"
                    :key="item.dateFrom"
                    :date.sync="formattedDateFrom"
                    @input="fromDateFocusOut"
                    :masks="{input: 'DD/MM/YY'}"
                    :inputProps="{
                      placeholder: $t('reservation.service-list.from-day')
                    }"
                  ></core-calendar>
                  <input v-if="item.statusCode === 'DONE' || item.statusCode === 'CANCELLED'" type="text" readonly v-model="calendarLikeDateFrom">
                </div>
                <div class="col col-50px border-right bg-lightdark" v-if="!item.buildingBlock">
                  <core-calendar
                    v-if="item.statusCode !== 'DONE' && item.statusCode !== 'CANCELLED'"
                    @change="handleCalendarChange"
                    :key="item.dateUntil"
                    :date.sync="formattedDateUntil"
                    :masks="{input: 'DD/MM/YY'}"
                    @input="untilDateFocusOut"
                    :inputProps="{
                      placeholder: $t('reservation.service-list.until-day')
                    }"
                  ></core-calendar>
                  <input v-if="item.statusCode === 'DONE' || item.statusCode === 'CANCELLED'" type="text" readonly v-model="calendarLikeDateUntil">
                </div>
                <div class="col col-50px border-right bg-lightdark" v-if="!item.buildingBlock">
                  <core-money-input :placeholder="$t('reservation.service-list.purchase-price')" readonly :amount="subTotalPurchasePrice" :key="subTotalPurchasePrice"></core-money-input>
                </div>
                <div class="col col-50px border-right bg-lightdark" v-if="!item.buildingBlock">
                  <core-money-input :placeholder="$t('reservation.service-list.sale-price')" readonly :amount="subTotalSalePrice" :key="subTotalSalePrice"></core-money-input>
                </div>
                <div class="col-30px border-right bg-lightdark" v-if="!item.buildingBlock">
                  <input readonly type="text" :value="item.showData ? 'Y' : 'N'" />
                </div>
                <div class="col-30px border-right bg-lightdark" v-if="!item.buildingBlock">
                  <input readonly type="text" :value="item.showPrices ? 'Y' : 'N'" />
                </div>
                <div class="col-30px border-right bg-lightdark" v-if="!item.buildingBlock">
                  <input readonly type="text" :value="item.automaticallyBooked ? 'A' : 'M'" />
                </div>
                <div class="col-2 border-right d-flex flex-row flex-space-between bg-lightdark"
                     :class="{ 'status-green': item.statusCode === 'DONE', 'status-blue': item.statusCode === 'TODO', 'status-orange': item.statusCode === 'PENDING', 'status-red': item.statusCode === 'CANCELLED' || item.statusCode === 'DECLINED' }"
                     style="padding:0"
                     @click="stopPropagation"
                     v-if="!extra && !item.buildingBlock"
                >
                  <select class="form-control" style="width: 70px" :item.sync="item.reservationStatusId" v-model="item.reservationStatusId">
                    <option v-if="(item.statusCode !== 'DONE' && item.statusCode !== 'CANCELLED') || ((status.code === 'DONE' && item.statusCode !== 'CANCELLED') || status.code === 'CANCELLED')" :key="status.id" :value="status.id" v-for="status in statuses">{{statusNameField(status)}}</option>
                  </select>
                  <div v-if="!autoBookingInProgress && item.statusCode === 'TODO' && !item.isLocked && item.service.email && item.service.externalApi < 1 && item.service.autoMail > 0 && !item.new && item.reservationLines.length > 0">
                    <button v-tooltip.left-start="tooltipInfo()" class="action-button btn-custom-small btn-custom-send" @click="sendBooking">{{ $t('reservation.send-booking') }}</button>
                  </div>
                  <div v-if="!autoBookingInProgress && item.statusCode === 'TODO' && (item.service.relativeBookingLink || item.service.absoluteBookingLink) && canBeBooked(item)">
                    <img src="@/assets/svg/refresh-ccw.svg" alt="loading" v-if="isBookingNow && !item.service.absoluteBookingLink" class="rotating" />
                    <button class="action-button btn-custom-small book-btn" v-if="!isBookingNow || item.service.absoluteBookingLink" :class="{ 'green-btn': item.service.relativeBookingLink, 'orange-btn': item.service.absoluteBookingLink }" @click="goToBookingPage">{{ $t('reservation.book-by-beds') }}</button>
                  </div>
                  <div v-if="!autoBookingInProgress && item.statusCode === 'TODO' && item.service.externalApi && item.service.externalApi !== '0' && item.service.bedsHotelCode && !item.new && item.reservationLines.length > 0 && !item.new">
                    <button v-if="!isBooking && !item.isLocked && hasRate" class="action-button btn-custom-small book-btn" @click="bookByBeds">{{ $t('reservation.book-by-beds') }}</button>
                    <img src="@/assets/svg/refresh-ccw.svg" alt="loading" v-if="isBooking" class="rotating">
                  </div>
                  <div v-if="!autoBookingInProgress && item.statusCode === 'TODO' && item.service && item.service.serviceType && item.service.serviceType.code === 'INSURANCE' && item.reservationLines.length > 0 && !item.new">
                    <button v-if="!isBooking && !item.isLocked " class="action-button btn-custom-small book-btn green-btn" @click="bookInsurance">{{ $t('reservation.book-insurance') }}</button>
                    <img src="@/assets/svg/refresh-ccw.svg" alt="loading" v-if="isBooking" class="rotating">
                  </div>
                  <div v-if="!autoBookingInProgress && item.statusCode === 'DONE' && item.service && item.service.serviceType && item.service && item.service.serviceType.code === 'INSURANCE' && item.reservationLines.length > 0 && item.reference">
                    <button v-if="!isBooking && !item.isLocked " class="action-button btn-custom-cancel-all btn-custom-small book-btn" @click="cancelInsuranceBooking">{{ $t('reservation.cancel-insurance') }}</button>
                    <img src="@/assets/svg/refresh-ccw.svg" alt="loading" v-if="isBooking" class="rotating">
                  </div>
                  <div v-if="!autoBookingInProgress && (item.statusCode === 'DONE') && item.bedsBookingReference">
                    <button v-if="!isBooking && hasRateInfo" class="action-button btn-custom-small book-btn" style="margin-top: 0px" :id='"cancel-btn-" + item.id' @click="cancelBookingByBeds" ref="cancelButton">{{ freeCancel ? $t('reservation.free-cancel-booking-by-beds') : $t('reservation.fee-cancel-booking-by-beds')}}</button>
                    <img src="@/assets/svg/refresh-ccw.svg" alt="loading" v-if="isBooking" class="rotating">
                  </div>
                  <input v-if="item.statusCode === 'DONE' && 0" readonly type="text" :value=getCurStatus() />
                  <div v-if="item.statusCode === 'TODO'">
                    <core-calendar
                      :masks="{input: 'DD/MM/YY'}"
                      :key="item.actionDate"
                      :date.sync="item.actionDate"
                      :inputProps="{
                      placeholder: $t('reservation.action-date')
                    }"
                    ></core-calendar>
                  </div>
                  <div v-if="item.statusCode === 'DONE'">
                    <input readonly type="text" :value="dateShortFormat(item.bookingDate)"/>
                  </div>
                </div>
                <div v-if="!item.buildingBlock" class="col col-50px border-right d-flex flex-row flex-space-between bg-lightdark">
                  <core-calendar
                    :masks="{input: 'DD/MM/YY'}"
                    :key="item.dateToBook"
                    :date.sync="item.dateToBook"
                    :inputProps="{
                        placeholder: 'Date to book'
                      }"
                  ></core-calendar>
                </div>
                <div v-if="!item.buildingBlock" class="col-40px border-right text-center bg-lightdark" style="font-weight: bold">
                  <select class="form-control" :item.sync="item.bookingPriority" v-model="item.bookingPriority">
                    <option :key=val :value=val v-for="val in Array.from(Array(10).keys())">{{ val }}</option>
                  </select>
                </div>
                <div v-if="item.buildingBlock && this.item.service.id" class="border-right text-center bg-lightdark" style="font-weight: bold">
                  <button class="action-button btn-custom btn-apply-building-block" @click="addLinesFromBuildingBlock">
                    {{ $t('reservation.service-list.apply') }}</button>
                </div>
                <div v-if="item.buildingBlock" class="border-right text-center bg-lightdark col-7" style="font-weight: bold">
                </div>
            </div>
        </div>
        <div class="pl-3 d-flex align-items-center" style="z-index: 1;">
            <core-icon
                @click.native="deleteItem"
                class="pointer"
                :iconName="$t('general.delete')"
                iconColor="#bdbdbd"
            >
                <icons-close></icons-close>
            </core-icon>
            <img v-if="!item.buildingBlock"
              @click="copyItem"
              class="add-row"
              src="@/assets/svg/plus008CDD.svg"
            />
        </div>
    </li>
</template>

<script>
import { clickOutside } from '@/mixins/clickOutside'
import Service from '../../services/hatsApi/Service'
import ReservationLine from '../../services/hatsApi/ReservationLine'
import ReservationLineExtra from '@/services/hatsApi/ReservationLineExtra'

export default {
  props: {
    wrapperClass: {
      default: 'd-flex justify-content-start move-item',
      type: String,
      required: false
    },
    outboundDate: {
      type: String,
      required: false
    },
    reservationDateFrom: {
      type: String,
      required: false
    },
    reservationDateUntil: {
      type: String,
      required: false
    },
    item: {
      type: Object,
      required: true
    },
    serviceTypes: {
      default: () => [],
      type: Array,
      required: true
    },
    serviceLinks: {
      default: () => [],
      type: Array,
      required: false
    },
    extra: {
      default: false,
      type: Boolean
    },
    prices: {
      default: () => {},
      type: Object | Array,
      required: true
    },
    statuses: {
      default: () => {},
      type: Object | Array,
      required: true
    },
    travelers: {
      default: () => {},
      type: Object | Array,
      required: true
    },
    index: {
      default: 0,
      type: Number,
      required: true
    },
    bookingId: {
      default: '0',
      type: String | Number,
      required: true
    },
    language: {
      default: null,
      type: Object,
      required: true
    },
    isBooking: {
      default: false,
      type: Boolean,
      required: false
    },
    autoBookingInProgress: {
      default: false,
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      isBookingNow: false,
      showCodeSearch: false,
      showNameSearch: false,
      prio: Array.from(new Array(31), (val, index) => index),
      formattedDateFrom: this.frontEndDateFormat(this.item.dateFrom),
      formattedDateUntil: this.frontEndDateFormat(this.item.dateUntil),
      calendarLikeDateFrom: this.frontEndDateFormat(this.item.dateFrom, 'DD/MM/YY'),
      calendarLikeDateUntil: this.frontEndDateFormat(this.item.dateUntil, 'DD/MM/YY'),
      subTotalSalePrice: 0,
      localServiceTypes: [],
      subTotalPurchasePrice: 0
    }
  },
  mixins: [clickOutside],
  methods: {
    tooltipInfo () {
      let tooltip = ''
      if (this.item.service.serviceType.code === 'ACCOMMODATION') {
        this.serviceLinks.forEach((link) => {
          if (link.service.id === this.item.service.id && link.serviceLinkBackups && link.serviceLinkBackups[0]) {
            tooltip = 'Has backup hotel: ' + link.serviceLinkBackups[0].service.title_NL
          }
        })
      }
      return tooltip
    },
    stopPropagation () {
      this.$emit('dont-load-right-side', this.item.id)
    },
    async bookByBeds () {
      this.item.isLocked = true
      this.$emit('beds-booking', this.item.id)
    },
    async bookInsurance () {
      this.item.isLocked = true
      this.$emit('beds-insurance', this.item)
    },
    async cancelBookingByBeds () {
      this.$emit('beds-booking-cancel', this.item, this.freeCancel)
    },
    async cancelInsuranceBooking () {
      this.$emit('insurance-booking-cancel', this.item)
    },
    dateShortFormat (date) {
      return this.$moment(date, 'YYYY-MM-DD').format('DD/MM/YY')
    },
    canBeBooked (item) {
      if (!parseInt(item.service.daysBeforeBooking)) {
        return true
      }
      let dateOfLastPossibleBooking = this.$moment().add(item.service.daysBeforeBooking, 'days').format('YYYYMMDD')
      let dateFrom = this.$moment(item.dateFrom, 'YYYY-MM-DD').format('YYYYMMDD')
      if (dateFrom <= dateOfLastPossibleBooking) {
        return true
      }
      return false
    },
    async goToBookingPage () {
      let url = ''
      let isPass = this.item.service.relativeBookingLink && this.item.service.relativeBookingLink.indexOf('/pass/') !== -1
      if (this.item.service.relativeBookingLink) {
        if (isPass) {
          url = this.item.service.relativeBookingLink + '?departure=' + this.item.dateFrom
        } else {
          url = this.item.service.relativeBookingLink + '&departure=' + this.item.dateFrom
        }
        let cl = []
        let defaultSeatType = ''
        this.item.reservationLines.forEach((item) => {
          let isFirst = parseInt(item.service.class) === 1 || (!item.service.class && (item.service.name.indexOf('1st') !== -1 || item.service.name.indexOf('1e klas') !== -1))
          let curClass = isFirst ? 1 : 2
          cl.push(curClass)
          defaultSeatType = defaultSeatType || (item.service ? item.service.defaultSeatType : '')
        })
        // get unique array
        cl = cl.filter((item, i, ar) => ar.indexOf(item) === i)
        if (cl.length !== 1 || !this.travelers.length || (!isPass && (!this.item.departureTime || !this.item.arrivalTime))) {
          window.open(url, '_blank')
        } else {
          this.isBookingNow = true
          let result = await ReservationLine.puppeteerBooking({
            'url': url,
            'bookingId': this.bookingId,
            'languageId': this.language.id,
            'class': cl[0],
            'reservationLineId': this.item.id,
            'arrivalTime': this.item.arrivalTime,
            'departureTime': this.item.departureTime,
            'seatType': defaultSeatType,
            'travelers': this.travelers
          })
          if (result.data.success) {
            location.reload()
          } else {
            this.isBookingNow = false
            this.$emit('set-update-message', result.data.errors[0].message)
          }
        }
      } else if (this.item.service.absoluteBookingLink) {
        url = this.item.service.absoluteBookingLink
        window.open(url, '_blank')
      }
    },
    sendBooking () {
      this.statuses.forEach((status) => {
        if (status.code === 'PENDING') {
          this.item.reservationStatusId = status.id
        }
      })
      this.item.pendingNote = 'confirmation email is sent, waiting for a response'
      this.item.confirmationIsSent = true
      // this.item.token = ''
      this.$emit('send-booking', this.item.id)
    },
    statusNameField (status) {
      return status ? status['name_' + this.$i18n.locale.toUpperCase()] : ''
    },
    getCurStatus () {
      let name = ''
      this.statuses.forEach((status) => {
        if (status.id === this.item.reservationStatusId) {
          name = this.statusNameField(status)
        }
      })
      return name
    },
    handleCalendarChange (val, selected, placeholder) {
      this.$emit('list-item-change', val, selected, placeholder, this.index)
    },
    determineSupplierType (isActive) {
      return (parseInt(isActive) === 1) ? this.$t('reservation.service-list.stock') : this.$t('reservation.service-list.free-sale')
    },
    addLinesFromBuildingBlock () {
      this.$emit('add-line-from-building-block', this.item.service.id)
    },
    async selectItem () {
      if (this.item.extraIsLoaded) {
        this.$emit('select')
        return
      }
      let ids = [this.item.id]
      this.item.reservationLines.forEach((item) => {
        if (!ids.includes(item.id)) {
          ids.push(item.id)
        }
      })

      let filters = [
        {
          property: 'reservationLineId',
          value: ids
        }
      ]
      const reservationExtraResponse = await ReservationLineExtra.getInfo(filters)
      if (reservationExtraResponse.data.success && reservationExtraResponse.data.data.length) {
        reservationExtraResponse.data.data.forEach((item) => {
          if (parseInt(item.reservationLineId) === parseInt(this.item.id)) {
            this.item.dayToDayText = reservationExtraResponse.data.data[0].dayToDay
            // this.item.notes = reservationExtraResponse.data.data[0].notes
          }
          this.item.reservationLines.forEach((subItem) => {
            if (parseInt(subItem.id) === parseInt(item.reservationLineId)) {
              subItem.cancellationData = reservationExtraResponse.data.data[0].cancellationData
              // subItem.notes = reservationExtraResponse.data.data[0].notes
            }
          })
          this.item.extraIsLoaded = true
        })
      }
      this.$emit('select')
    },
    deleteItem () {
      this.$emit('delete')
    },
    copyItem () {
      this.$emit('copy-row', this.item)
    },
    toggleCodeSearch () {
      this.showCodeSearch = true
      if (this.showCodeSearch) {
        this.showNameSearch = false
      }
    },
    toggleNameSearch () {
      this.showNameSearch = true
      if (this.showNameSearch) {
        this.showCodeSearch = false
      }
    },
    outsideNameSearch () {
      this.showNameSearch = false
    },
    outsideCodeSearch () {
      this.showCodeSearch = false
    },
    fromDateFocusOut (val) {
      this.item.dateFrom = val
      let from = this.$moment(this.item.dateFrom, 'YYYY-MM-DD')
      let end = this.$moment(this.item.dateUntil, 'YYYY-MM-DD')

      // If end date is before from date, update the end date to from date
      if (end.isBefore(from) || !this.item.dateUntil) {
        let previousDateTo = this.item.dateUntil
        setTimeout(() => {
          this.item.dateUntil = this.item.dateFrom
          this.formattedDateUntil = this.frontEndDateFormat(this.item.dateUntil)
          this.$emit('list-item-change', previousDateTo, this.item.dateUntil, 'until-day', this.index)
        }, 100)
      }
    },
    fromDateFocusIn () {
      this.formattedDateFrom = this.frontEndDateFormat(this.item.dateFrom)
    },
    untilDateFocusOut (val) {
      this.item.dateUntil = val

      let from = this.$moment(this.item.dateFrom, 'YYYY-MM-DD')
      let end = this.$moment(this.item.dateUntil, 'YYYY-MM-DD')

      // If end-date is before start date, update the end-date from start-date
      if (end.isBefore(from)) {
        let previousDateFrom = this.item.dateFrom
        setTimeout(() => {
          this.item.dateFrom = this.item.dateUntil
          this.formattedDateFrom = this.frontEndDateFormat(this.item.dateFrom)
          this.$emit('list-item-change', previousDateFrom, this.item.dateFrom, 'from-day', this.index)
        }, 100)
      }
    },
    untilDateFocusIn () {
      this.formattedDateUntil = this.frontEndDateFormat(this.item.dateUntil)
    },
    frontEndDateFormat (date, format) {
      if (!date) {
        return ''
      }
      if (format) {
        return this.$moment(date, 'YYYY-MM-DD').format(format)
      } else {
        return this.$moment(date, 'YYYY-MM-DD')
      }
    },
    backEndDateFormat (date) {
      if (!date) {
        return ''
      }
      return this.$moment(date, 'DD/MM/YY').format('YYYY-MM-DD')
    },
    getSubTotal (priceType) {
      if (!this.prices) {
        return 0
      }
      let reservationLinePrice = this.prices[this.index]
      if (reservationLinePrice) {
        // Free sale
        if (reservationLinePrice.hasOwnProperty('reservationLines') && reservationLinePrice.reservationLines.length) {
          return this.$_.sumBy(reservationLinePrice.reservationLines, (rPrice) => {
            return parseFloat(rPrice[priceType])
          })
        } else if (reservationLinePrice.hasOwnProperty('rollingStockCoupes') && reservationLinePrice.rollingStockCoupes.length) {
          // Stock
          return this.$_.sumBy(reservationLinePrice.rollingStockCoupes, (rPrice) => {
            return parseFloat(rPrice[priceType])
          })
        } else {
          return 0
        }
      } else {
        return 0
      }
    }
  },
  created: function () {
    if (this.item.buildingBlock) {
      this.serviceTypes.forEach((item) => {
        if (item.code === 'PREBUILD_BLOCK') {
          this.localServiceTypes.push(item)
        }
      })
    } else {
      this.localServiceTypes = this.serviceTypes
    }
  },
  computed: {
    hasRate () {
      let has = false
      this.item.reservationLines.forEach((item) => {
        if (item.amount > 0 && item.bedsRoomRate) {
          has = true
        }
      })
      return has
    },
    hasRateInfo () {
      let has = false
      this.item.reservationLines.forEach((item) => {
        if (item.amount > 0 && item.rate) {
          has = true
        }
      })
      return has
    },
    freeCancel () {
      let dates = []
      this.item.reservationLines.forEach((item) => {
        if (item.amount > 0 && ((item.rate && item.rate.cancellationPolicies) || item.cancellationData)) {
          let cancellationData = []
          if (item.cancellationData) {
            if (typeof item.cancellationData === 'string' && item.cancellationData !== '') {
              cancellationData = JSON.parse(item.cancellationData)
            } else {
              cancellationData = item.cancellationData
            }
          } else {
            cancellationData = item.rate.cancellationPolicies
          }
          if (cancellationData && cancellationData[0]) {
            cancellationData.forEach((el) => {
              dates.push(this.$moment(el.from).format('YYYY-MM-DD HH:mm'))
            })
          }
        }
      })
      dates = dates.sort()
      let firstDate = dates[0]
      if (dates && firstDate) {
        if (this.$moment(firstDate, 'YYYY-MM-DD HH:mm').format('YYYYMMDD') > this.$moment(new Date()).format('YYYYMMDD')) {
          return true
        }
      }
      return false
    }
  },
  watch: {
    'item.service': {
      async handler (val) {
        if (this.item.service && this.item.service.serviceType && this.item.service.serviceType.code === 'INSURANCE') {
          if (!this.item.dateFrom) {
            this.item.dateFrom = this.reservationDateFrom
            this.item.dateUntil = this.reservationDateUntil ? this.reservationDateUntil : this.reservationDateFrom
          }
        }
        this.$set(this.item, 'serviceId', this.item.service.id)
        this.$set(this.item, 'supplierType', this.determineSupplierType(this.item.service.stock))

        if (this.item.service.id) {
          let serviceResponse = await Service.getService(this.item.service.id)
          if (serviceResponse.data.success) {
            this.$set(this.item, 'dayToDayText', serviceResponse.data.data['travelDocument_' + this.language.code])
          }
        }
      }
    },
    'item.reservationStatusId': {
      handler () {
        this.statuses.forEach((status, index) => {
          if (status.id === this.item.reservationStatusId) {
            this.$emit('status-code-change', this.item.id, status.code)
          }
        })
      }
    },
    'item.dateFrom': {
      handler (val) {
        this.formattedDateFrom = this.frontEndDateFormat(val)
        this.item.dateToBook = this.frontEndDateFormat(val)
      }
    },
    'item.dateUntil': {
      handler (val) {
        this.formattedDateUntil = this.frontEndDateFormat(val)
      }
    },
    prices: {
      handler () {
        this.subTotalSalePrice = this.getSubTotal('subTotalSalePrice')
        this.subTotalPurchasePrice = this.getSubTotal('subTotalPurchasePrice')
      },
      immediate: false
    }
  }
}
</script>

<style lang="scss">
.reservation-line-row{
  > div {
    height: 34px;
    /*line-height: 34px;*/
  }
  .col-30px select {
    border: none;
    text-align: center;
  }
  select {
    height: 34px;
  }
}
.col-15px {
  width: 15px;
  text-align: center;
  padding:0;
  input[type="text"] {
    text-align: center;
    width: 15px;
  }
}
.col-30px{
  width: 30px;
  text-align: center;
  padding:0;
  input {
    text-align: center;
    width: 20px;
  }
  select {
    padding: 0;
    text-align: center!important;
  }
}
.col-40px {
  width: 40px;
  text-align: center;
  padding:0;
  input[type="text"] {
    width: 40px;
    text-align: center;
  }
  select {
    padding: 0;
    text-align: center;
  }
}
.col-50px {
  width: 50px;
  padding:0;
  input {
    width: 50px;
    text-align: center;
  }
}
.col-60px{
  width: 60px;
  padding:0;
  input[type="number"], input[type="input"], input[type="text"] {
    text-align: center;
  }
}
.col-70px {
  width: 70px;
  padding:0;
  text-align: center;
}
.col-80px {
  width: 80px;
  padding:0;
  text-align: center;
}
.col-90px{
  width: 90px;
  padding:0;
  input[type="text"] {
    text-align: center;
  }
}
.btn-custom-small {
  border-radius: 5px;
  color: white;
  line-height: 14px;
}
.flex-space-between {
  justify-content: space-between
}
.bg-lightdark{
  background: #F8F8F8;
  select {
    background: #F8F8F8;
  }
}
@mixin white-inside {
  > div {
    color: white!important;
    .autocomplete-group {
      color: #414141!important;
    }
    &.no-bg{
      background: transparent;
      color: black;
    }
    select, select option, select option:checked{
      color: white!important;
    }
  }
  input[type="number"], input[type="input"], input[type="text"], .status-green {
    color: white!important
  }
  select {
    color: white!important;
    border: none;
  }
}
.book-btn{
  background: #008CDD;
  margin-top: 8px;
  border: 1px solid #0099e5;
  cursor: pointer;
}
.green-btn{
  background: #12b47d;
}
.orange-btn{
  background: #F59B00;
}
.row-green{
  > div {
    background: #12b47d;
  }
  select {
    background: #12b47d!important;
  }
  @include white-inside;
}
.row-red{
  > div {
    background: #A50000;
  }
  select {
    background: #A50000!important;
  }
  @include white-inside;
}
.row-orange{
  > div {
    background: #F59B00;
  }
  select {
    background: #F59B00!important;
  }
  @include white-inside;
}
.row-blue{
  > div {
    background: #008CDD;
  }
  select {
    background: #008CDD!important;
  }
  @include white-inside;
}
</style>



// WEBPACK FOOTER //
// src/components/reservation/ServiceListItem.vue